import * as React from "react";
import { ModalButtonClose } from "../generic/common/ModalButtonClose";
import { ModalOverlay } from "../modals/ModalOverlay";
export var TransparentDialogWrapper = function (_a) {
    var onClose = _a.onClose, _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children, _c = _a.overlay, overlay = _c === void 0 ? true : _c;
    var TransparentDialogOverlay = overlay ? ModalOverlay : React.Fragment;
    return (React.createElement(TransparentDialogOverlay, null,
        React.createElement("div", { className: "modal " + className },
            React.createElement("div", { className: "modal-content" },
                onClose && (React.createElement(ModalButtonClose, { onClick: onClose, className: "modal-header__close" })),
                React.createElement("section", { className: "modal-section" }, children)))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/transparent-dialog/TransparentDialogWrapper.tsx
// module id = 309
// module chunks = 3